var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOilBarrel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_5704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_5704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 42C7.6 42 7.25 41.85 6.95 41.55C6.65 41.25 6.5 40.8917 6.5 40.475C6.5 40.0583 6.65 39.7083 6.95 39.425C7.25 39.1417 7.6 39 8 39H10V25.5H7.5C7.1 25.5 6.75 25.35 6.45 25.05C6.15 24.75 6 24.3917 6 23.975C6 23.5583 6.15 23.2083 6.45 22.925C6.75 22.6417 7.1 22.5 7.5 22.5H10V9H8C7.6 9 7.25 8.85 6.95 8.55C6.65 8.25 6.5 7.89167 6.5 7.475C6.5 7.05833 6.65 6.70833 6.95 6.425C7.25 6.14167 7.6 6 8 6H40C40.425 6 40.7813 6.14375 41.0688 6.43125C41.3563 6.71875 41.5 7.075 41.5 7.5C41.5 7.9 41.3563 8.25 41.0688 8.55C40.7813 8.85 40.425 9 40 9H38V22.5H40.5C40.925 22.5 41.2813 22.6437 41.5688 22.9312C41.8563 23.2188 42 23.575 42 24C42 24.4 41.8563 24.75 41.5688 25.05C41.2813 25.35 40.925 25.5 40.5 25.5H38V39H40C40.425 39 40.7813 39.1438 41.0688 39.4313C41.3563 39.7188 41.5 40.075 41.5 40.5C41.5 40.9 41.3563 41.25 41.0688 41.55C40.7813 41.85 40.425 42 40 42H8ZM13 39H35V25.5C34.6 25.5 34.25 25.35 33.95 25.05C33.65 24.75 33.5 24.3917 33.5 23.975C33.5 23.5583 33.65 23.2083 33.95 22.925C34.25 22.6417 34.6 22.5 35 22.5V9H13V22.5C13.425 22.5 13.7813 22.6437 14.0688 22.9312C14.3563 23.2188 14.5 23.575 14.5 24C14.5 24.4 14.3563 24.75 14.0688 25.05C13.7813 25.35 13.425 25.5 13 25.5V39ZM24.0059 31.35C25.5353 31.35 26.8333 30.8226 27.9 29.7679C28.9667 28.7131 29.5 27.4366 29.5 25.9386C29.5 24.7462 29.1583 23.7333 28.475 22.9C27.7917 22.0667 26.3 20.3167 24 17.65C21.7 20.2833 20.2083 22.025 19.525 22.875C18.8417 23.725 18.5 24.7462 18.5 25.9386C18.5 27.4366 19.0353 28.7131 20.1059 29.7679C21.1765 30.8226 22.4765 31.35 24.0059 31.35Z",
    fill: "#0BAB47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilBarrel);
export default __webpack_public_path__ + "static/media/oil_barrel.c2e87c3669b6594f55054dff31259b64.svg";
export { ForwardRef as ReactComponent };